import { render, staticRenderFns } from "./WarrantyActions.vue?vue&type=template&id=a118f6fc&"
import script from "./WarrantyActions.vue?vue&type=script&lang=js&"
export * from "./WarrantyActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports